const ROLE_CUSTOMER = 'ROLE_CUSTOMER';
const ROLE_MANAGER = 'ROLE_MANAGER';
const ROLE_SERVICES = 'ROLE_SERVICES';

class Roles {
  static values = [ROLE_MANAGER, ROLE_CUSTOMER, ROLE_SERVICES];

  static labelOf = (role) => {
    switch (role) {
      case ROLE_MANAGER:
        return 'Manager';
      case ROLE_CUSTOMER:
        return 'Customer';
      case ROLE_SERVICES:
        return 'Services';
      default:
        throw new Error(`Invalid role '${role}' provided`);
    }
  }

  static isManager(role) {
    return role === ROLE_MANAGER;
  }

  static isCustomer(role) {
    return role === ROLE_CUSTOMER;
  }

  static default = () => ROLE_CUSTOMER;

  static labels = () => ['Manager', 'Customer', 'Services'];
}

export default Roles;
